import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, CircularProgress, Grid, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { useTranslation } from "react-i18next";
import { repliValidator } from '../../../components';
import UserInformationForm from "./UserInformationForm.component";
import PatientGeneralInformationForm from "./PatientGeneralInformationForm.component";
import PatientPregnancyInformationForm from "./PatientPregnancyInformationForm.component";
import PatientAdoptionInformationForm from './PatientAdoptionInformationForm.component';
import PatientStepchildrenInformationForm from './PatientStepchildrenInformationForm.component';
import PatientChildrenDeathInformationForm from './PatientChildrenDeathInformationForm.component';
import PatientContraceptiveMethodsInformationForm from "./PatientContraceptiveMethodsInformationForm.component";
import PatientFertilityPreservationInformationForm from './PatientFertilityPreservationInformationForm.component';
import PatientFertilityTreatmentInformationForm from './PatientFertilityTreatmentInformationForm.component';
import PatientCancerDiagnosisAndTreatmentsInfoForm from './PatientCancerDiagnosisAndTreatmentsInfoForm.component';
import Bariatrics from './Bariatrics.component'
import useStyles from "./Create.style";
import Cookies from 'universal-cookie';
import { Link } from 'react-router-dom';
import TimelineIcon from '@material-ui/icons/Timeline';
import FamilyHistory from './FamilyHistory.component';
import GeneticTesting from './GeneticTesting.component';
import { arrayOfNumbers } from '../../../services/util.service';

const cookies = new Cookies();

const Create = () => {
    const classes = useStyles();
    const history = useHistory();
    const { t } = useTranslation();

    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [currentChildren, setCurrentChildren] = useState('');
    const [thoughtAboutDesChildren, setThoughtAboutDesChildren] = useState('');
    const [desiredChildren, setDesiredChildren] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [firstPeriodAge, setFirstPeriodAge] = useState('');
    const [sexualDebutAge, setSexualDebutAge] = useState('');
    /* Menopause module */
    const [menopause, setMenopause] = useState('');
    const [menopauseAge, setMenopauseAge] = useState('');
    const [menopauseStatus, setMenopauseStatus] = useState('');
    const [menopauseReason, setMenopauseReason] = useState('');
    const [menopauseSymptonAge, setMenopauseSymptonAge] = useState('');
    const [selectedMenopauseSymptons, setSelectedMenopauseSymptons] = useState([]);
    const [childbearingYearFrame, setChildbearingYearFrame] = useState([18, 45]);
    const [pregnancies, setPregnancies] = useState([]);
    const [adoptions, setAdoptions] = useState([]);
    const [stepchildren, setStepchildren] = useState([]);
    const [childrenDeath, setChildrenDeath] = useState([]);
    const [gender, setGender] = useState('');
    const [relationshipStatus, setRelationshipStatus] = useState('');
    const [selectedRaces, setSelectedRaces] = useState([]);
    const [raceSelfDescribe, setRaceSelfDescribe] = useState('');
    const [genderIdentity, setGenderIdentity] = useState('');
    const [genderIdentitySelfDescribe, setGenderIdentitySelfDescribe] = useState('');
    const [selectedSexualPreferences, setSelectedSexualPreferences] = useState([]);
    const [sexualPreferenceSelfDescribe, setSexualPreferenceSelfDescribe] = useState('');
    const [contraceptiveMethods, setContraceptiveMethods] = useState([]);
    const [fertilityPreservationMethods, setFertilityPreservationMethods] = useState([]);
    const [fertilityTreatments, setFertilityTreatments] = useState([]);
    const [anyCancerDiagnosis, setCancerDiagnosis] = useState('');
    const [pendingCancerDiagnosis, setPendingCancerDiagnosis] = useState('');
    const [otherPendingCancerDiagnosis, setOtherPendingCancerDiagnosis] = useState('');
    const [currentSiteOfCancer, setCurrentSiteOfCancer] = useState('');
    const [cancerDiagnosisAndTreatments, setCancerDiagnosisAndTreatments] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [sending, setSending] = useState(false);
    const [saveResult, setSaveResult] = useState({});
    const [saveSuccessResultId, setSaveSuccessResultId] = useState();
    const [childrenPlan, setChildrenPlan] = useState('');
    const [plannedChildBearingYears, setPlannedChildBearingYears] = useState('');
    // Family history properties
    const [fhGeneralDiseases, setFhGeneralDiseases] = useState([]);
    const [fhBehavioral, setFhBehavioral] = useState([]);
    const [fhCardiovascular, setFhCardiovascular] = useState([]);
    const [fhEndocrine, setFhEndocrine] = useState([]);
    const [fhGastrointestinal, setFhGastrointestinal] = useState([]);
    const [fhHematologic, setFhHematologic] = useState([]);
    const [fhImmunologic, setFhImmunologic] = useState([]);
    const [fhNeurologic, setFhNeurologic] = useState([]);
    const [fhOncologic, setFhOncologic] = useState([]);
    const [fhPsychiatric, setFhPsychiatric] = useState([]);
    const [fhRespiratory, setFhRespiratory] = useState([]);
    const [fhReproductive, setFhReproductive] = useState([]);

    //Genetic Testing module 
    const [anyGeneticTesting, setAnyGeneticTesting] = useState('');
    const [geneticTesting, setGeneticTesting] = useState([]);

    const [patientOrg, setPatientOrg] = useState("");
    const [providerOrgs, setProviderOrgs] = useState([]);
    const [department, setDeparment] = useState("")
    const [loginUserId, setLoginUserId] = useState("");

    // Bariatrics
    const [hereForBariatricCare, setHereForBariatricCare] = useState('')
    const [hereForBariatricsOrWeightManagement, setHereForBariatricsOrWeightManagement] = useState('')
    const [whatObesityMedicationsTaking, setWhatObesityMedicationsTaking] = useState('')
    const [currentWeight, setCurrentWeight] = useState('')
    const [desiredWeightPriorToPregnency, setDesiredWeightPriorToPregnency] = useState('')
    const [bariatricSurgeryPlanning, setBariatricSurgeryPlanning] = useState('')
    const [typeOfPreviousSurgery, setTypeOfPreviousSurgery] = useState('')
    const [dateOfPreviousSurgery, setDateOfPreviousSurgery] = useState('')
    const [previousStaringWeight, setPreviousStaringWeight] = useState('')
    const [previousCurrentWeight, setPreviousCurrentWeight] = useState('')
    const [previousDesiredWeight, setPreviousDesiredWeight] = useState('')
    const [meetingVitaminGoals, setMeetingVitaminGoals] = useState('')
    const [desireBariatricSurgery, setDesireBariatricSurgery] = useState('')
    const [currentlyEnrolled, setCurrentlyEnrolled] = useState('')
    const [futureCurrentWeight, setFutureCurrentWeight] = useState('')
    const [futureDesiredWeight, setFutureDesiredWeight] = useState('')



    const currentYear = new Date().getFullYear();

    const validator = useRef(repliValidator({
        validators: {
            otherFertilityMethod: {
                message: 'Please specify the other method',
                rule: (val, params, validator) => {
                    return params[0] !== 'Other' || val !== '';
                },
                required: true
            },
            race_self_describe: {
                message: 'Please self describe your race',
                rule: (val, params, validator) => {
                    if (params.includes('Prefer to self-describe')) return val !== '';
                    return true;
                },
                required: true
            },
            gender_identity_self_describe: {
                message: 'Please self describe your gender identity',
                rule: (val, params, validator) => {
                    if (params[0] === 'Gender identity not listed') return val !== '';
                    return true;
                },
                required: true
            },
            sexual_preference_self_describe: {
                message: 'Please self describe your sexual preference',
                rule: (val, params, validator) => {
                    if (params.includes('Prefer to self-describe')) return val !== '';
                    return true;
                },
                required: true
            },
            period_year: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (!['', 'None'].includes(params[0])) return val !== '';
                    return true;
                },
                required: true
            },
            menopause_field: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (['Yes'].includes(params[0])) return val !== '';
                    return true;
                },
                required: true
            },

            menopause_age: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (['Yes', 'Unsure'].includes(params[0])) return val !== '';
                    return true;
                },
                required: true
            },
            menopause_unsure: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (['Unsure'].includes(params[0])) return val.length >= 3;
                    return true;
                },
                required: true
            },
            menopause_unsure_age: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (['Unsure'].includes(params[0])) return val !== '';
                    return true;
                },
                required: true
            },

            describe_pending_cancer_diagnosis: {
                message: 'Please select pending cancer diagnosis',
                rule: (val, params, validator) => {
                    if (params[0] === 'Yes') return val !== '';
                    return true;
                },
                required: true
            },
            describe_other_pending_cancer_diagnosis: {
                message: 'Please describe other pending cancer diagnosis',
                rule: (val, params, validator) => {
                    if (params[0] === 'Other') return val !== '';
                    return true;
                },
                required: true
            },
            describe_current_site_of_cancer: {
                message: 'Please describe your current site of cancer',
                rule: (val, params, validator) => {
                    if (params[0] === 'Currently') return val !== '';
                    return true;
                },
                required: true
            },
            other_site_of_cancer: {
                message: 'Please describe other site of cancer',
                rule: (val, params, validator) => {
                    if (params[0] === 'Other') return val !== '';
                    return true;
                },
                required: true
            },
            other_treatment_type: {
                message: 'Please describe other treatment type',
                rule: (val, params, validator) => {
                    if (params[0] === 'Other') return val !== '';
                    return true;
                },
                required: true
            },
            other_site_of_oncologic: {
                message: 'Please describe other site of Oncologic',
                rule: (val, params, validator) => {
                    if (params[0] === 'Other') return val !== '';
                    return true;
                },
                required: true
            },
            treatment_year: {
                message: 'Please select the year',
                rule: (val, params, validator) => {
                    if (!['None'].includes(params[0])) return val !== '';
                    return true;
                },
                required: true
            },
            other_testType: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if ((params[0] === 'Other' || params[0] === 'Carrier screening') && params[1] === 'Yes') return val !== '';
                    return true;
                },
                required: true
            },
            cancer_geneType: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (params[0] === 'Cancer genetic testing' && params[1] === 'Yes') return val !== '';
                    return true;
                },
                required: true
            },
            test_field_req: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (params[0] === 'Yes') return val !== '';
                    return true;
                },
                required: true
            },
            thoughtAboutDesChildren: {
                message: 'This field is required',
                rule: (val, params, validator) => val !== "",
                required: true
            },
            hereForBariatricCare: {
                message: 'This field is required',
                rule: (val, params, validator) => val !== "",
                required: true
            },
            hereForBariatricsOrWeightManagement: {
                message: 'This field is required.',
                rule: (val, params, validator) => {
                    if (params[0] === 'Yes') return val !== '';
                    return true;
                },
                required: true
            },
            currentWeight: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (["Weight management"].includes(params[0])) return val > 0;
                    return true;
                },
                required: true
            },
            desiredWeightPriorToPregnency: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (["Weight management"].includes(params[0])) return val > 0;
                    return true;
                },
                required: true
            },
            previousStaringWeight: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (["Previous surgery"].includes(params[0])) return val > 0;
                    return true;
                },
                required: true
            },
            previousCurrentWeight: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (["Previous surgery"].includes(params[0])) return val > 0;
                    return true;
                },
                required: true
            },
            previousDesiredWeight: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (["Previous surgery"].includes(params[0])) return val > 0;
                    return true;
                },
                required: true
            },
            futureCurrentWeight: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (["Future surgery"].includes(params[0])) return val > 0;
                    return true;
                },
                required: true
            },
            futureDesiredWeight: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (["Future surgery"].includes(params[0])) return val > 0;
                    return true;
                },
                required: true
            },
        }
    }));

    // useEffect(() => {
    //     if (saveResult.severity === "success") {
    //         setTimeout(() => history.push("/provider/provider/mypatients"), 2000);
    //     }
    // }, [saveResult, history]);


    useEffect(() => {
        const loadAccountInfo = async () => {
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_AUTH_SIGNEDUSER}`,
                    {
                        headers: {
                            "X-ACCESS-TOKEN": cookies.get("token"),
                        },
                    }
                );
                let json = await response.json();
                if (!response.ok) {

                    return;
                }
                setProviderOrgs(json.organizations);
                setLoginUserId(json._id);

            } catch (error) {
                console.log(error);
            }
        };
        loadAccountInfo();
    }, [t]);




    const handlePregnancyOutcomeDataChange = index => e => {
        let modifiedData = pregnancies.map((data, i) => i === index ?
            {
                ...data,
                outcome: e.target.value,
                liveBirthQty: 0,
                stillbirthQty: 0,
                placedAdoptionQty: 0,
                isProviderView: 'true'
            }
            : data);
        setPregnancies(modifiedData);
    };

    const handleFertilityMethodChange = index => e => {
        let modifiedData = fertilityPreservationMethods.map((data, i) => {
            if (i === index) {
                const validInput = new RegExp(/[a-zA-Z0-9][\\sa-zA-Z0-9]{0,40}/);
                if (validInput.test(e.target.value) || e.target.value === '') {
                    data.otherMethod = e.target.value;
                }
            }
            return data;
        });
        setFertilityPreservationMethods(modifiedData);
    };

    const handleArrayItemChange = (array, setter) => (index, field) => e => {
        let modifiedData = array.map((data, i) => {
            if (i === index) {
                data[field] = e.target.value;
                if (data["yearFrom"]) {
                    data[field] = e.target.value;
                }
                if (data["yearFrom"] === "Unknown time of use") {
                    data["yearTo"] = "Unknown time of use"
                }
                if (data["yearTo"] !== "" && data["yearTo"] < data["yearFrom"]) {
                    data["yearTo"] = "";
                    data["yearFrom"] = "";
                }
                else {
                    data[field] = e.target.value
                }


                if (data?.method !== "Other" && data?.otherMethod) {
                    data.otherMethod = '';
                    // data.yearFrom = '';
                    // data.yearTo = '';
                }
                else if (data[field] === "None") {
                    data.yearFrom = '';
                    data.yearTo = '';

                }


            }
            return data;
        });
        setter(modifiedData);
    };

    const handleCancerDiagnosisChangeInArray = index => e => {
        let modifiedData = cancerDiagnosisAndTreatments.map((data, i) => i === index ?
            {
                ...data,
                siteOfCancer: e.target.value,
                otherSiteOfCancer: e.target.value !== 'Other' ? '' : data.otherSiteOfCancer
            }
            : data);
        setCancerDiagnosisAndTreatments(modifiedData);
    }

    const handleCancerTreatmentChangeInArray = (event, treatmentProperty, treatmentIndex, cancerIndex) => {
        let modifiedData = cancerDiagnosisAndTreatments.map((data, i) => {
            if (i === cancerIndex) {

                if (['None'].includes(event.target.value) && treatmentProperty === 'treatmentType') {
                    data.treatments[treatmentIndex].otherTreatmentType = '';
                    data.treatments[treatmentIndex].treatmentFromYear = '';
                    data.treatments[treatmentIndex].treatmentToYear = '';
                    data.treatments[treatmentIndex].treatmentType = 'None';
                }
                else if (data.treatments[treatmentIndex].treatmentType === 'Other' && treatmentProperty === 'otherTreatmentType') {
                    const validInput = new RegExp(/[a-zA-Z0-9][\\sa-zA-Z0-9]{0,40}/);
                    if (validInput.test(event.target.value) || event.target.value === '') {
                        data.treatments[treatmentIndex][treatmentProperty] = event.target.value;
                    }
                }
                else if (treatmentProperty === 'treatmentFromYear') {
                    data.treatments[treatmentIndex][treatmentProperty] = event.target.value;
                    data.treatments[treatmentIndex].toYears = [...arrayOfNumbers((event.target.value), (currentYear - (event.target.value) + 1))];
                    if (data.treatments[treatmentIndex].treatmentToYear !== "" && (data.treatments[treatmentIndex].treatmentFromYear) > (data.treatments[treatmentIndex].treatmentToYear)) {
                        data.treatments[treatmentIndex][treatmentProperty] = "";
                        data.treatments[treatmentIndex].treatmentToYear = '';
                    }
                    else {
                        data.treatments[treatmentIndex][treatmentProperty] = event.target.value;
                        data.treatments[treatmentIndex].toYears = [...arrayOfNumbers((event.target.value), (currentYear - (event.target.value) + 1))];
                    }
                }
                else if (treatmentProperty === 'treatmentToYear') {
                    if ((event.target.value) < (data.treatments[treatmentIndex].treatmentFromYear)) {
                        data.treatments[treatmentIndex][treatmentProperty] = "";
                        data.treatments[treatmentIndex].treatmentFromYear = '';
                    }
                    else {
                        data.treatments[treatmentIndex][treatmentProperty] = event.target.value;
                    }
                }
                else {
                    data.treatments[treatmentIndex][treatmentProperty] = event.target.value;
                    if (data.treatments[treatmentIndex].treatmentType === 'Other' && treatmentProperty === 'otherTreatmentType') {
                        data.treatments[treatmentIndex][treatmentProperty] = event.target.value.trimStart();
                    }
                }
            }
            return data;
        });
        setCancerDiagnosisAndTreatments(modifiedData);
    }

    const handleAddItemStateArray = (currentArray, newItemDefault, setter) => async e => {
        let newArray = [...currentArray, newItemDefault];
        setter(newArray);
    };

    const handleAddTreatmentItemStateArray = (event, cancerIndex, currentArray, newDefaultTreatment) => {
        let modifiedData = cancerDiagnosisAndTreatments.map((data, i) => {
            if (i === cancerIndex) {
                let newArray = [...currentArray, newDefaultTreatment];
                data.treatments = newArray;
            }
            return data;
        });
        setCancerDiagnosisAndTreatments(modifiedData);
    };

    const handleRemoveItemStateArray = (currentArray, setter) => removeIndex => e => {
        let remainingData = [...currentArray];
        remainingData.splice(removeIndex, 1);
        setter(remainingData);
    };

    const handleStateArrayItemChange = (array, setter) => (index, field) => e => {
        let modifiedData = array.map((data, i) => {
            if (i === index) {
                if (field === 'otherSiteOfCancer') {
                    const validInput = new RegExp(/[a-zA-Z0-9][\\sa-zA-Z0-9]{0,40}/);
                    if (validInput.test(e.target.value) || e.target.value === '') {
                        data[field] = e.target.value;
                    }
                } else {
                    data[field] = e.target.value;
                }
            }
            return data;
        });
        setter(modifiedData);
    };

    const handleStateArrayItemChangeOncologic = (array, setter) => (index, field) => e => {
        let modifiedData = array.map((data, i) => {
            if (i === index) {
                if (field === 'othersiteofOncologic') {
                    const validInput = new RegExp(/[a-zA-Z0-9][\\sa-zA-Z0-9]{0,40}/);
                    if (validInput.test(e.target.value) || e.target.value === '') {
                        data[field] = e.target.value;
                    }
                } else {
                    data[field] = e.target.value;
                }
            }
            return data;
        });
        setter(modifiedData);
    };

    // Family history Functions
    const handleFhAddItemStateArray = (type, newItemDefault) => async e => {
        if (type === "generalAssessment") {
            handleFhTypeAddItemStateArray(fhGeneralDiseases, setFhGeneralDiseases, newItemDefault);
        }
        else if (type === "behavioral") {
            handleFhTypeAddItemStateArray(fhBehavioral, setFhBehavioral, newItemDefault);
        }
        else if (type === "cardiovascular") {
            handleFhTypeAddItemStateArray(fhCardiovascular, setFhCardiovascular, newItemDefault);
        }
        else if (type === "endocrine") {
            handleFhTypeAddItemStateArray(fhEndocrine, setFhEndocrine, newItemDefault);
        }
        else if (type === "gastrointestinal") {
            handleFhTypeAddItemStateArray(fhGastrointestinal, setFhGastrointestinal, newItemDefault);
        }
        else if (type === "hematologic") {
            handleFhTypeAddItemStateArray(fhHematologic, setFhHematologic, newItemDefault);
        }
        else if (type === "immunologic") {
            handleFhTypeAddItemStateArray(fhImmunologic, setFhImmunologic, newItemDefault);
        }
        else if (type === "neurologic") {
            handleFhTypeAddItemStateArray(fhNeurologic, setFhNeurologic, newItemDefault);
        }
        else if (type === "oncologic") {
            handleFhTypeAddItemStateArray(fhOncologic, setFhOncologic, newItemDefault);
        }
        else if (type === "psychiatric") {
            handleFhTypeAddItemStateArray(fhPsychiatric, setFhPsychiatric, newItemDefault);
        }
        else if (type === "respiratory") {
            handleFhTypeAddItemStateArray(fhRespiratory, setFhRespiratory, newItemDefault);
        }
        else if (type === "reproductive") {
            handleFhTypeAddItemStateArray(fhReproductive, setFhReproductive, newItemDefault);
        }
    };

    const handleFhTypeAddItemStateArray = (array, setter, newItemDefault) => {
        let newArray = [...array, newItemDefault];
        setter(newArray);
    }

    const handleFhRemoveItemStateArray = (type, removeIndex) => e => {
        if (type === "generalAssessment") {
            handleFhTypeRemoveItemStateArray(fhGeneralDiseases, setFhGeneralDiseases, removeIndex);
        }
        else if (type === "behavioral") {
            handleFhTypeRemoveItemStateArray(fhBehavioral, setFhBehavioral, removeIndex);
        }
        else if (type === "cardiovascular") {
            handleFhTypeRemoveItemStateArray(fhCardiovascular, setFhCardiovascular, removeIndex);
        }
        else if (type === "endocrine") {
            handleFhTypeRemoveItemStateArray(fhEndocrine, setFhEndocrine, removeIndex);
        }
        else if (type === "gastrointestinal") {
            handleFhTypeRemoveItemStateArray(fhGastrointestinal, setFhGastrointestinal, removeIndex);
        }
        else if (type === "hematologic") {
            handleFhTypeRemoveItemStateArray(fhHematologic, setFhHematologic, removeIndex);
        }
        else if (type === "immunologic") {
            handleFhTypeRemoveItemStateArray(fhImmunologic, setFhImmunologic, removeIndex);
        }
        else if (type === "neurologic") {
            handleFhTypeRemoveItemStateArray(fhNeurologic, setFhNeurologic, removeIndex);
        }
        else if (type === "oncologic") {
            handleFhTypeRemoveItemStateArray(fhOncologic, setFhOncologic, removeIndex);
        }
        else if (type === "psychiatric") {
            handleFhTypeRemoveItemStateArray(fhPsychiatric, setFhPsychiatric, removeIndex);
        }
        else if (type === "respiratory") {
            handleFhTypeRemoveItemStateArray(fhRespiratory, setFhRespiratory, removeIndex);
        }
        else if (type === 'reproductive') {
            handleFhTypeRemoveItemStateArray(fhReproductive, setFhReproductive, removeIndex);
        }
    };

    const handleFhTypeRemoveItemStateArray = (array, setter, index) => {
        let remainingData = [...array];
        remainingData.splice(index, 1);
        setter(remainingData);
    }

    const handleFhStateArrayItemChange = (type, index, field, newValue) => e => {
        if (type === "generalAssessment") {
            handleFhTypeStateArrayItemChange(fhGeneralDiseases, setFhGeneralDiseases, index, field, newValue);
        }
        else if (type === "behavioral") {
            handleFhTypeStateArrayItemChange(fhBehavioral, setFhBehavioral, index, field, newValue);
        }
        else if (type === "cardiovascular") {
            handleFhTypeStateArrayItemChange(fhCardiovascular, setFhCardiovascular, index, field, newValue);
        }
        else if (type === "endocrine") {
            handleFhTypeStateArrayItemChange(fhEndocrine, setFhEndocrine, index, field, newValue);
        }
        else if (type === "gastrointestinal") {
            handleFhTypeStateArrayItemChange(fhGastrointestinal, setFhGastrointestinal, index, field, newValue);
        }
        else if (type === "hematologic") {
            handleFhTypeStateArrayItemChange(fhHematologic, setFhHematologic, index, field, newValue);
        }
        else if (type === "immunologic") {
            handleFhTypeStateArrayItemChange(fhImmunologic, setFhImmunologic, index, field, newValue);
        }
        else if (type === "neurologic") {
            handleFhTypeStateArrayItemChange(fhNeurologic, setFhNeurologic, index, field, newValue);
        }
        else if (type === "oncologic") {
            handleFhTypeStateArrayItemChange(fhOncologic, setFhOncologic, index, field, newValue);
        }
        else if (type === "psychiatric") {
            handleFhTypeStateArrayItemChange(fhPsychiatric, setFhPsychiatric, index, field, newValue);
        }
        else if (type === "respiratory") {
            handleFhTypeStateArrayItemChange(fhRespiratory, setFhRespiratory, index, field, newValue);
        }
        else if (type === 'reproductive') {
            handleFhTypeStateArrayItemChange(fhReproductive, setFhReproductive, index, field, newValue);
        }
    };

    const handleFhTypeStateArrayItemChange = (array, setter, index, field, newValue) => {
        let dataNewValue = newValue;
        if (newValue.includes('None')) {
            dataNewValue = ['None'];
        }
        let modifiedData = array.map(
            (data, i) => {
                if (i === index) data[field] = dataNewValue;
                return data;
            }
        );
        setter(modifiedData);
    };

    const handleMenopauseChange = e => {
        setMenopause(e.target.value);
        if (e.target.value === 'No') {
            setMenopauseAge('');
            setMenopauseReason('');
            setMenopauseStatus('');
            setSelectedMenopauseSymptons([]);
            setMenopauseSymptonAge('');
        } else if (e.target.value === 'Unsure') {
            setMenopauseAge('');
            setMenopauseReason('');
            setMenopauseStatus('');
        }
        else {
            setSelectedMenopauseSymptons([]);
            setMenopauseSymptonAge('');
        }
    };


    const handleSubmit = async e => {
        e.preventDefault();
        setSubmitted(true);

        const isValid = validator.current.allValid();

        if (!isValid) {
            validator.current.showMessages();
            setSaveResult({
                severity: "error",
                message: `${t('module.provider.addPatient.message.addPatientFailure')}. ${t('common.message.error.validationError')}.`
            });
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            return;
        }
        else {
            // check for the Current Children Qty
            const pregnanciesOutcomeQty = pregnancies
                .map(pregnancy => pregnancy.liveBirthQty - pregnancy.placedAdoptionQty)
                .reduce((acc, item) => acc + item, 0);
            const stepchildrenQty = parseInt(stepchildren.reduce((acc, stepchild) => acc + parseInt(stepchild.stepchildrenQty), 0));
            const adoptionsQty = parseInt(adoptions
                .reduce((acc, adoption) => acc + parseInt(adoption.childrenQty), 0));
            const lossesQty = parseInt(childrenDeath
                .reduce((acc, loss) => acc + parseInt(loss.childrenQty), 0));

            const currentChildrenQtyFromProfile = pregnanciesOutcomeQty + adoptionsQty + stepchildrenQty - lossesQty;

            if (currentChildrenQtyFromProfile !== parseInt(currentChildren)) {
                setSaveResult({
                    severity: "error",
                    message: `${t('common.message.error.ChildrenQytError')}.`
                });
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
                return;
            }

            if (thoughtAboutDesChildren === '' || childrenPlan === '') {
                setSaveResult({
                    severity: "error",
                    message: `Please check all fields.`
                });
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
                return;
            }

            if (childrenPlan === 'Yes' && plannedChildBearingYears === '') {
                setSaveResult({
                    severity: "error",
                    message: `Please check all fields.`
                })
            }

            if (patientOrg === "") {
                setSaveResult({
                    severity: "error",
                    message: `${t('common.message.error.organizationError')}.`
                });
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
                return;
            }
            if (department === "") {
                setSaveResult({
                    severity: "error",
                    message: `${t('common.message.error.departmentError')}.`
                });
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
                return;
            }

            if (hereForBariatricCare === "") {
                setSaveResult({
                    severity: "error",
                    message: `${t('common.message.error.validationError')}.`
                });
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
                return;
            }

            if (hereForBariatricCare === "Yes") {

                if (hereForBariatricsOrWeightManagement === "") {
                    setSaveResult({
                        severity: "error",
                        message: `${t('common.message.error.validationError')}.`
                    });
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                    return;
                }

            }

            if (hereForBariatricsOrWeightManagement === "Bariatric surgery") {

                if (bariatricSurgeryPlanning === "") {
                    setSaveResult({
                        severity: "error",
                        message: `${t('common.message.error.validationError')}.`
                    });
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                    return;
                }

            }


            setSending(true);

            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT}`, {
                    method: 'post',
                    body: new URLSearchParams({
                        email: email,
                        firstName: firstName,
                        lastName: lastName,
                        createdBy: loginUserId,
                        createdFrom: 'RepLi',
                        currentChildrenQty: currentChildren,
                        thoughtAboutDesChildren: thoughtAboutDesChildren,
                        desiredChildrenQty: (thoughtAboutDesChildren === 'Yes') && desiredChildren ? desiredChildren : "",
                        dateOfBirth: dateOfBirth,
                        organization: patientOrg,
                        department: department,
                        firstPeriodAge: firstPeriodAge,
                        sexualDebutAge: sexualDebutAge,
                        menopauseAge: menopauseAge,
                        menopause: menopause,
                        menopauseStatus: menopauseStatus,
                        menopauseReason: menopauseReason,
                        menopauseSymptonAge: menopauseSymptonAge,
                        selectedMenopauseSymptons: selectedMenopauseSymptons,
                        childrenPlan: childrenPlan,
                        plannedChildBearingYears: plannedChildBearingYears,
                        childbearingYearFrame: childbearingYearFrame,
                        gender: gender,
                        genderIdentity: genderIdentity,
                        genderIdentitySelfDescribe: genderIdentitySelfDescribe,
                        relationshipStatus: relationshipStatus,
                        races: selectedRaces,
                        raceSelfDescribe: raceSelfDescribe,
                        sexualPreferences: selectedSexualPreferences,
                        sexualPreferenceSelfDescribe: sexualPreferenceSelfDescribe,
                        anyCancerDiagnosis: anyCancerDiagnosis,
                        currentSiteOfCancer: currentSiteOfCancer,
                        pendingCancerDiagnosis: pendingCancerDiagnosis,
                        otherPendingCancerDiagnosis: otherPendingCancerDiagnosis,
                        anyGeneticTesting: anyGeneticTesting,
                        pregnancies: JSON.stringify(pregnancies),
                        adoptions: JSON.stringify(adoptions),
                        stepchildren: JSON.stringify(stepchildren),
                        childrenLoss: JSON.stringify(childrenDeath),
                        contraception: JSON.stringify(contraceptiveMethods),
                        fertilityPreservation: JSON.stringify(fertilityPreservationMethods),
                        fertilityTreatment: JSON.stringify(fertilityTreatments),
                        cancerDiagnosisAndTreatments: JSON.stringify(cancerDiagnosisAndTreatments),
                        fhGeneralDiseases: JSON.stringify(fhGeneralDiseases),
                        fhBehavioral: JSON.stringify(fhBehavioral),
                        fhCardiovascular: JSON.stringify(fhCardiovascular),
                        fhEndocrine: JSON.stringify(fhEndocrine),
                        fhGastrointestinal: JSON.stringify(fhGastrointestinal),
                        fhHematologic: JSON.stringify(fhHematologic),
                        fhImmunologic: JSON.stringify(fhImmunologic),
                        fhNeurologic: JSON.stringify(fhNeurologic),
                        fhOncologic: JSON.stringify(fhOncologic),
                        fhPsychiatric: JSON.stringify(fhPsychiatric),
                        fhRespiratory: JSON.stringify(fhRespiratory),
                        fhReproductive: JSON.stringify(fhReproductive),
                        geneticTesting: JSON.stringify(geneticTesting),

                        //Bariatrics
                        hereForBariatricCare: hereForBariatricCare,
                        hereForBariatricsOrWeightManagement: hereForBariatricCare === "Yes" ? hereForBariatricsOrWeightManagement : '',
                        whatObesityMedicationsTaking: whatObesityMedicationsTaking,
                        currentWeight: currentWeight,
                        desiredWeightPriorToPregnency: desiredWeightPriorToPregnency,
                        bariatricSurgeryPlanning: bariatricSurgeryPlanning,
                        typeOfPreviousSurgery: typeOfPreviousSurgery,
                        dateOfPreviousSurgery: dateOfPreviousSurgery,
                        previousStaringWeight: previousStaringWeight,
                        previousCurrentWeight: previousCurrentWeight,
                        previousDesiredWeight: previousDesiredWeight,
                        meetingVitaminGoals: meetingVitaminGoals,
                        desireBariatricSurgery: desireBariatricSurgery,
                        currentlyEnrolled: currentlyEnrolled,
                        futureCurrentWeight: futureCurrentWeight,
                        futureDesiredWeight: futureDesiredWeight,

                    }),
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    }
                });

                if (!response.ok) {
                    setSaveResult({
                        severity: "error",
                        message: response.message || response.errors[0].msg
                    });
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                    return;
                }
                else {
                    let json = await response.json();
                    setSaveSuccessResultId(json._id);
                    setSaveResult({
                        severity: "success",
                        message: t('module.provider.addPatient.message.addPatientSuccess')
                    });
                }
            } catch (error) {
                console.log(error);
                setSaveResult({
                    severity: "error",
                    message: `${t('module.provider.addPatient.message.addPatientFailure')}. ${t('common.message.error.seeLog')}.`
                });
            } finally {
                setSending(false);
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            };
        }

    };

    const isRaceChecked = race => {
        return selectedRaces.includes(race);
    };

    const handleSelectedRacesCheck = race => {
        if (!isRaceChecked(race))
            setSelectedRaces([...selectedRaces, race]);
        else
            setSelectedRaces(selectedRaces.filter(item => item !== race));
    };

    const isSexualPreferenceChecked = preference => {
        return selectedSexualPreferences.includes(preference);
    };

    const handleGenderIdentityChange = e => {
        setGenderIdentity(e.target.value)
        if (e.target.value !== 'Gender identity not listed') {
            setGenderIdentitySelfDescribe('');
        }
    }

    const handleSelfDescribeChange = (e, selfDescribeType) => {
        const validSelfDescribe = new RegExp(/[a-zA-Z0-9][\\sa-zA-Z0-9]{0,40}/);

        if (validSelfDescribe.test(e.target.value) || e.target.value === '') {
            if (selfDescribeType === "Race Self Describe") {
                setRaceSelfDescribe(e.target.value);
            }
            else if (selfDescribeType === "Gender Identity Self Describe") {
                setGenderIdentitySelfDescribe(e.target.value);
            }
            else if (selfDescribeType === "Sexual Preference Self Describe") {
                setSexualPreferenceSelfDescribe(e.target.value);
            }
            else if (selfDescribeType === "Current Site of Cancer") {
                setCurrentSiteOfCancer(e.target.value)
            }
        }
    }

    const handleSexualPreferenceCheck = preference => {
        if (!isSexualPreferenceChecked(preference))
            setSelectedSexualPreferences([...selectedSexualPreferences, preference]);
        else
            setSelectedSexualPreferences(selectedSexualPreferences.filter(item => item !== preference));
    };

    const handleCancerDiagnosisChange = e => {
        setCancerDiagnosis(e.target.value);
        if (e.target.value === 'No' || e.target.value === 'Currently') {
            setCancerDiagnosisAndTreatments([]);
            setCurrentSiteOfCancer('');
        }
        else {
            setCancerDiagnosisAndTreatments([{
                siteOfCancer: '',
                otherSiteOfCancer: '',
                year: '',
                treatments: [{
                    treatmentType: '',
                    otherTreatmentType: '',
                    treatmentFromYear: '',
                    treatmentToYear: '',
                    fromYears: [],
                    toYears: []
                }]
            }]);
        }
    };

    const handleCancerDiagnosisYearChange = (event, index) => {
        let modifiedData = cancerDiagnosisAndTreatments.map((data, i) => {
            if (i === index) {
                data["year"] = event.target.value;
                if (data["year"]) {
                    data["treatments"].forEach(treatment => {
                        treatment.fromYears = [...arrayOfNumbers((data["year"]), (currentYear - (data["year"]) + 1))]
                        treatment.toYears = [...arrayOfNumbers((data["year"]), (currentYear - (data["year"]) + 1))]
                    }
                    )
                }
            }
            return data;
        });
        setCancerDiagnosisAndTreatments(modifiedData);
    }

    const handleAnyGenticTestingChange = e => {
        setAnyGeneticTesting(e.target.value);
        if (e.target.value === 'No' || e.target.value === 'Unsure') {
            setGeneticTesting([]);
        }
        else {
            setGeneticTesting([{
                testType: '',
                anyPositiveGeneticTesting: '',
                otherTestType: '',
                cancerGeneType: '',
                year: '',
                copyOfGeneticTesting: '',
            }])
        }
    }

    const handlePositiveGeneticTestingChange = (index, value) => {
        let modifiedData = geneticTesting.map(
            (data, i) => {
                if (i === index && (value === 'No' || value === 'Unsure')) {
                    data['anyPositiveGeneticTesting'] = value;
                    data['otherTestType'] = '';
                    data['cancerGeneType'] = '';
                    data['year'] = '';
                    data['copyOfGeneticTesting'] = '';
                } else if (i === index && value === 'Yes') {
                    data['anyPositiveGeneticTesting'] = value;
                }
                return data;
            }
        );
        setGeneticTesting(modifiedData);
    }

    const handleTreatmentDelete = (event, treatmentIndex, cancerIndex) => {
        let modifiedData = cancerDiagnosisAndTreatments.map((data, i) => {
            if (i === cancerIndex) {
                data.treatments.splice(treatmentIndex, 1);
            }
            return data;
        });
        setCancerDiagnosisAndTreatments(modifiedData);
    }


    const handleChildrenPlanChange = (e, newValue) => {
        setChildrenPlan(newValue);
        if (newValue === 'No') {
            setChildbearingYearFrame([]);
            setPlannedChildBearingYears('');
        }
    };

    const handleThoughtAboutDesChildren = (e, newValue) => {
        setThoughtAboutDesChildren(newValue);
        if (newValue === 'No' || newValue === 'Undecided') {
            setDesiredChildren('')
        }
    }

    const handlePlannedChildBearingYears = (e, newValue) => {
        setPlannedChildBearingYears(newValue);
        if (newValue === 'No')
            setChildbearingYearFrame([])
        else
            if (childbearingYearFrame === undefined || !childbearingYearFrame?.length)
                setChildbearingYearFrame([18, 45]);
    };


    const isMenopauseSymptonChecked = sympton => {
        return selectedMenopauseSymptons.includes(sympton);
    };

    const handleMenopauseSymptonChange = sympton => {
        if (!isMenopauseSymptonChecked(sympton))
            setSelectedMenopauseSymptons([...selectedMenopauseSymptons, sympton]);
        else
            setSelectedMenopauseSymptons(selectedMenopauseSymptons.filter(item => item !== sympton));
    };


    const handleBariatricsOrWeightManagementChange = (value) => {
        setHereForBariatricsOrWeightManagement(value);

        // If user selects "Bariatric surgery", clear the obesity medications field
        if (value === "Bariatric surgery") {
            setWhatObesityMedicationsTaking(""); // Clear the field
            setCurrentWeight('');
            setDesiredWeightPriorToPregnency('')
        }
        if (value === "Weight management") {
            setBariatricSurgeryPlanning('')
            setTypeOfPreviousSurgery('')
            setDateOfPreviousSurgery('')
            setPreviousStaringWeight('')
            setPreviousCurrentWeight('')
            setPreviousDesiredWeight('')
            setMeetingVitaminGoals('')
            setDesireBariatricSurgery('')
            setCurrentlyEnrolled('')
            setFutureCurrentWeight('')
            setFutureDesiredWeight('')
        }
    };
    const handleBariatricCareChange = (e) => {
        setHereForBariatricCare(e.target.value)
        if (e.target.value === 'No' || e.target.value === 'Unsure') {
            setHereForBariatricsOrWeightManagement('')
            setWhatObesityMedicationsTaking(""); // Clear the field
            setCurrentWeight('');
            setDesiredWeightPriorToPregnency('')
            setBariatricSurgeryPlanning('')
            setTypeOfPreviousSurgery('')
            setDateOfPreviousSurgery('')
            setPreviousStaringWeight('')
            setPreviousCurrentWeight('')
            setPreviousDesiredWeight('')
            setMeetingVitaminGoals('')
            setDesireBariatricSurgery('')
            setCurrentlyEnrolled('')
            setFutureCurrentWeight('')
            setFutureDesiredWeight('')
        }
    }
    const handleBariatricSurgeryPlanningChange = (value) => {
        setBariatricSurgeryPlanning(value)
        if (value === 'Previous surgery') {
            setDesireBariatricSurgery('')
            setCurrentlyEnrolled('')
            setFutureCurrentWeight('')
            setFutureDesiredWeight('')
        }
        if (value === 'Future surgery') {
            setTypeOfPreviousSurgery('')
            setDateOfPreviousSurgery('')
            setPreviousStaringWeight('')
            setPreviousCurrentWeight('')
            setWhatObesityMedicationsTaking('')
            setPreviousDesiredWeight('')
            setMeetingVitaminGoals('')
        }
    }

    const handleChange = (setter) => (e) => {
        const value = e.target.value;
        const regex = /^\d*\.?\d{0,3}$/;
        if (value === '' || regex.test(value)) {
            setter(value);
        } else {
            setter('');
        }
    };


    return (
        <>
            <Typography variant="h4" className={classes.title}>
                {t('module.provider.addPatient.title')}
            </Typography>
            {(saveResult.message) ?
                (saveResult.severity !== 'success') ?
                    < Alert severity={saveResult.severity}>{saveResult.message}</Alert> :
                    < Grid style={{ display: "flex", padding: "1em" }}>
                        <Grid style={{ flex: "10%" }}><Alert severity={saveResult.severity}>{saveResult.message}</Alert></Grid>
                        <Grid style={{ marginLeft: 10 }}>
                            <Button fullWidth variant="contained"
                                color="secondary" component={Link} to={`/provider/repli/${saveSuccessResultId}`}> View RepLi
                                <TimelineIcon style={{ marginLeft: 20 }} /></Button>
                        </Grid>
                    </Grid>
                : ''
            }

            <Grid container>
                <Grid item md={8} xs={12}>
                    <form className={classes.form} onSubmit={handleSubmit}>
                        <UserInformationForm
                            id=''
                            email={email}
                            firstName={firstName}
                            lastName={lastName}
                            onEmailChange={e => setEmail(e.target.value.trim())}
                            onFirstNameChange={e => setFirstName(e.target.value.trimStart())}
                            onLastNameChange={e => setLastName(e.target.value.trimStart())}
                            submitted={submitted}
                            validator={validator.current}
                            editMode="insert"
                        />
                        <PatientGeneralInformationForm
                            currentChildren={currentChildren}
                            desiredChildren={desiredChildren}
                            thoughtAboutDesChildren={thoughtAboutDesChildren}
                            dateOfBirth={dateOfBirth}
                            firstPeriodAge={firstPeriodAge}
                            sexualDebutAge={sexualDebutAge}
                            menopause={menopause}
                            menopauseAge={menopauseAge}
                            menopauseSymptonAge={menopauseSymptonAge}
                            menopauseStatus={menopauseStatus}
                            menopauseReason={menopauseReason}
                            selectedMenopauseSymptons={selectedMenopauseSymptons}
                            childbearingYearFrame={childbearingYearFrame}
                            gender={gender}
                            relationshipStatus={relationshipStatus}
                            selectedRaces={selectedRaces}
                            raceSelfDescribe={raceSelfDescribe}
                            genderIdentity={genderIdentity}
                            genderIdentitySelfDescribe={genderIdentitySelfDescribe}
                            selectedSexualPreferences={selectedSexualPreferences}
                            sexualPreferenceSelfDescribe={sexualPreferenceSelfDescribe}
                            childrenPlan={childrenPlan}
                            plannedChildBearingYears={plannedChildBearingYears}
                            onCurrentChildrenChange={e => setCurrentChildren(e.target.value)}
                            onDesiredChildrenChange={e => setDesiredChildren(e.target.value)}
                            onDateOfBirthChange={e => setDateOfBirth(e.target.value)}
                            onFirstPeriodAgeChange={e => setFirstPeriodAge(e.target.value)}
                            onSexualDebutAgeChange={e => setSexualDebutAge(e.target.value)}
                            onPatientOrgChange={e => setPatientOrg(e.target.value)}
                            onMenopauseChange={handleMenopauseChange}
                            onMenopauseAgeChange={e => setMenopauseAge(e.target.value)}
                            onMenopauseStatusChange={e => setMenopauseStatus(e.target.value)}
                            onMenopauseReasonChange={e => setMenopauseReason(e.target.value)}
                            onMenopauseSymptonAgeChange={e => setMenopauseSymptonAge(String(e.target.value))}
                            onChildbearingYearFrameChange={(e, newValue) => setChildbearingYearFrame(newValue)}
                            onGenderChange={e => setGender(e.target.value)}
                            onRelationshipStatusChange={e => setRelationshipStatus(e.target.value)}
                            onSelectedRacesChange={handleSelectedRacesCheck}
                            onRaceSelfDescribeChange={(e, race) => handleSelfDescribeChange(e, race)}
                            onGenderIdentityChange={handleGenderIdentityChange}
                            onSexualPreferenceChange={handleSexualPreferenceCheck}
                            onSexualPreferenceSelfDescribeChange={(e, sexualPreference) => handleSelfDescribeChange(e, sexualPreference)}
                            onGenderIdentitySelfDescribeChange={(e, genderIdentity) => handleSelfDescribeChange(e, genderIdentity)}
                            onChildrenPlanChange={handleChildrenPlanChange}
                            handlePlannedChildBearingYears={handlePlannedChildBearingYears}
                            handleThoughtAboutDesChildren={handleThoughtAboutDesChildren}
                            onMenopauseSymptonChanges={handleMenopauseSymptonChange}
                            onDepartmentChange={e => setDeparment(e.target.value)}
                            patientOrg={patientOrg}
                            providerOrgs={providerOrgs}
                            department={department}
                            submitted={submitted}
                            validator={validator.current}
                        />
                        <PatientPregnancyInformationForm
                            mode="create"
                            pregnancies={pregnancies}
                            onPregnancyAdd={handleAddItemStateArray(
                                pregnancies,
                                {
                                    year: '',
                                    intention: '',
                                    outcome: '',
                                    isProviderView: 'true',
                                    liveBirthQty: 0,
                                    stillbirthQty: 0,
                                    placedAdoptionQty: 0
                                },
                                setPregnancies)}
                            onPregnancyDelete={handleRemoveItemStateArray(pregnancies, setPregnancies)}
                            onDataChange={handleStateArrayItemChange(pregnancies, setPregnancies)}
                            onOutcomeDataChange={handlePregnancyOutcomeDataChange}
                            submitted={submitted}
                            validator={validator.current}
                            dateOfBirth={dateOfBirth}
                            firstPeriodAge={firstPeriodAge}
                        />
                        <PatientAdoptionInformationForm
                            adoptions={adoptions}
                            onAdoptionAdd={handleAddItemStateArray(adoptions, { year: '', childrenQty: 0 }, setAdoptions)}
                            onAdoptionDelete={handleRemoveItemStateArray(adoptions, setAdoptions)}
                            onDataChange={handleStateArrayItemChange(adoptions, setAdoptions)}
                            submitted={submitted}
                            validator={validator.current}
                            dateOfBirth={dateOfBirth}
                            firstPeriodAge={firstPeriodAge}
                        />
                        <PatientStepchildrenInformationForm
                            stepchildren={stepchildren}
                            onStepchildrenAdd={handleAddItemStateArray(stepchildren, { year: '', stepchildrenQty: 0 }, setStepchildren)}
                            onStepchildrenDelete={handleRemoveItemStateArray(stepchildren, setStepchildren)}
                            onDataChange={handleStateArrayItemChange(stepchildren, setStepchildren)}
                            submitted={submitted}
                            validator={validator.current}
                            dateOfBirth={dateOfBirth}
                            firstPeriodAge={firstPeriodAge}
                        />
                        <PatientChildrenDeathInformationForm
                            childrenDeath={childrenDeath}
                            onChildrenDeathAdd={handleAddItemStateArray(childrenDeath, { year: '', childrenQty: 0 }, setChildrenDeath)}
                            onChildrenDeathDelete={handleRemoveItemStateArray(childrenDeath, setChildrenDeath)}
                            onDataChange={handleStateArrayItemChange(childrenDeath, setChildrenDeath)}
                            submitted={submitted}
                            validator={validator.current}
                            dateOfBirth={dateOfBirth}
                            firstPeriodAge={firstPeriodAge}
                        />
                        <PatientContraceptiveMethodsInformationForm
                            contraceptiveMethods={contraceptiveMethods}
                            onContraceptiveMethodsAdd={handleAddItemStateArray(contraceptiveMethods, { method: '', yearFrom: '', yearTo: '' }, setContraceptiveMethods)}
                            onContraceptiveMethodsDelete={handleRemoveItemStateArray(contraceptiveMethods, setContraceptiveMethods)}
                            onDataChange={handleArrayItemChange(contraceptiveMethods, setContraceptiveMethods)}
                            submitted={submitted}
                            validator={validator.current}
                            dateOfBirth={dateOfBirth}
                        />
                        <PatientFertilityPreservationInformationForm
                            fertilityPreservationMethods={fertilityPreservationMethods}
                            onFertilityPreservationMethodAdd={handleAddItemStateArray(fertilityPreservationMethods, { method: '', yearFrom: '', yearTo: '', otherMethod: '' }, setFertilityPreservationMethods)}
                            onFertilityPreservationMethodDelete={handleRemoveItemStateArray(fertilityPreservationMethods, setFertilityPreservationMethods)}
                            onDataChange={handleArrayItemChange(fertilityPreservationMethods, setFertilityPreservationMethods)}
                            onMethodChange={handleFertilityMethodChange}
                            submitted={submitted}
                            validator={validator.current}
                            dateOfBirth={dateOfBirth}
                        />
                        <PatientFertilityTreatmentInformationForm
                            fertilityTreatments={fertilityTreatments}
                            onFertilityTreatmentAdd={handleAddItemStateArray(fertilityTreatments, { treatment: '', yearFrom: '', yearTo: '' }, setFertilityTreatments)}
                            onFertilityTreatmentDelete={handleRemoveItemStateArray(fertilityTreatments, setFertilityTreatments)}
                            onDataChange={handleArrayItemChange(fertilityTreatments, setFertilityTreatments)}
                            submitted={submitted}
                            validator={validator.current}
                            dateOfBirth={dateOfBirth}
                        />
                        <FamilyHistory
                            fhGeneralDiseases={fhGeneralDiseases}
                            fhBehavioral={fhBehavioral}
                            fhCardiovascular={fhCardiovascular}
                            fhEndocrine={fhEndocrine}
                            fhGastrointestinal={fhGastrointestinal}
                            fhHematologic={fhHematologic}
                            fhImmunologic={fhImmunologic}
                            fhNeurologic={fhNeurologic}
                            fhOncologic={fhOncologic}
                            fhPsychiatric={fhPsychiatric}
                            fhRespiratory={fhRespiratory}
                            fhReproductive={fhReproductive}
                            submitted={submitted}
                            validator={validator.current}
                            onFhAdd={(type) => handleFhAddItemStateArray(
                                type,
                                {
                                    disease: "",
                                    othersiteofOncologic: '',
                                    self: "",
                                    heirs: []
                                })}
                            onFhRemove={(type, index) => handleFhRemoveItemStateArray(type, index)}
                            onFhDataChange={(type, index, field, newValue) => handleFhStateArrayItemChange(type, index, field, newValue)}
                            onDataChange={handleStateArrayItemChangeOncologic(fhOncologic, setFhOncologic)}
                        />
                        <PatientCancerDiagnosisAndTreatmentsInfoForm
                            cancerDiagnosisAndTreatments={cancerDiagnosisAndTreatments}
                            onCancerDiagnosisYearChange={(event, cancerIndex) => { handleCancerDiagnosisYearChange(event, cancerIndex) }}
                            onCancerDiagnosisAndTreatmentsAdd={handleAddItemStateArray(cancerDiagnosisAndTreatments, {
                                siteOfCancer: '',
                                otherSiteOfCancer: '',
                                year: '',
                                treatments: [{
                                    treatmentType: '',
                                    otherTreatmentType: '',
                                    treatmentFromYear: '',
                                    treatmentToYear: '',
                                    fromYears: [],
                                    toYears: []
                                }]
                            }, setCancerDiagnosisAndTreatments)}
                            onCancerDiagnosisAndTreatmentsDelete={handleRemoveItemStateArray(cancerDiagnosisAndTreatments, setCancerDiagnosisAndTreatments)}
                            onCancerDiagnosisChangeInArray={handleCancerDiagnosisChangeInArray}
                            onDataChange={handleStateArrayItemChange(cancerDiagnosisAndTreatments, setCancerDiagnosisAndTreatments)}
                            anyCancerDiagnosis={anyCancerDiagnosis}
                            currentSiteOfCancer={currentSiteOfCancer}
                            onCurrentSiteOfCancerChange={(e, currentSiteOfCancer) => handleSelfDescribeChange(e, currentSiteOfCancer)}
                            onCancerDiagnosisChange={handleCancerDiagnosisChange}
                            pendingCancerDiagnosis={pendingCancerDiagnosis}
                            otherPendingCancerDiagnosis={otherPendingCancerDiagnosis}
                            otherPendingCancerDiagnosisChange={e => setOtherPendingCancerDiagnosis(e.target.value)}
                            onPendingCancerDiagnosisChange={e => setPendingCancerDiagnosis(e.target.value)}
                            onCancerTreatmentChangeInArray={(event, treatmentProperty, treatmentIndex, cancerIndex) => handleCancerTreatmentChangeInArray(event, treatmentProperty, treatmentIndex, cancerIndex)}
                            onTreatmentAdd={(event, cancerIndex, currentArray, newDefaultTreatment) => handleAddTreatmentItemStateArray(event, cancerIndex, currentArray, newDefaultTreatment)}
                            onTreatmentDelete={(event, treatmentIndex, cancerIndex) => handleTreatmentDelete(event, treatmentIndex, cancerIndex)}
                            submitted={submitted}
                            validator={validator.current}
                            dateOfBirth={dateOfBirth}
                        />
                        <GeneticTesting
                            validator={validator.current}
                            submitted={submitted}
                            dateOfBirth={dateOfBirth}
                            anyGeneticTesting={anyGeneticTesting}
                            items={geneticTesting}
                            onGenticTestingChange={e => handleAnyGenticTestingChange(e)}
                            onPositiveGeneticTestingChange={(index, value) => handlePositiveGeneticTestingChange(index, value)}
                            onGeneticTestingAdd={handleAddItemStateArray(geneticTesting, {
                                testType: '',
                                anyPositiveGeneticTesting: '',
                                otherTestType: '',
                                cancerGeneType: '',
                                year: '',
                                copyOfGeneticTesting: ''
                            }, setGeneticTesting)}
                            onGeneticTestingRemove={handleRemoveItemStateArray(geneticTesting, setGeneticTesting)}
                            onDataChange={handleStateArrayItemChange(geneticTesting, setGeneticTesting)}
                        />
                        <Bariatrics
                            submitted={submitted}
                            validator={validator.current}
                            hereForBariatricCare={hereForBariatricCare}
                            setHereForBariatricCare={e => handleBariatricCareChange(e)}
                            hereForBariatricsOrWeightManagement={hereForBariatricsOrWeightManagement}
                            setHereForBariatricsOrWeightManagement={setHereForBariatricsOrWeightManagement}
                            handleBariatricsOrWeightManagementChange={e => handleBariatricsOrWeightManagementChange(e)}
                            whatObesityMedicationsTaking={whatObesityMedicationsTaking}
                            setWhatObesityMedicationsTaking={setWhatObesityMedicationsTaking}
                            currentWeight={currentWeight}
                            onCurrentWeightChange={handleChange(setCurrentWeight)}
                            desiredWeightPriorToPregnency={desiredWeightPriorToPregnency}
                            onDesiredWeightPriorToPregnencyChange={handleChange(setDesiredWeightPriorToPregnency)}
                            bariatricSurgeryPlanning={bariatricSurgeryPlanning}
                            handleBariatricSurgeryPlanningChange={(e) => handleBariatricSurgeryPlanningChange(e)}
                            typeOfPreviousSurgery={typeOfPreviousSurgery}
                            setTypeOfPreviousSurgery={setTypeOfPreviousSurgery}
                            dateOfPreviousSurgery={dateOfPreviousSurgery}
                            onDateOfPreviousSurgeryChange={e => setDateOfPreviousSurgery(e.target.value)}
                            previousStaringWeight={previousStaringWeight}
                            onPreviousStaringWeightChange={handleChange(setPreviousStaringWeight)}
                            previousCurrentWeight={previousCurrentWeight}
                            onPreviousCurrentWeightChange={handleChange(setPreviousCurrentWeight)}
                            previousDesiredWeight={previousDesiredWeight}
                            onPreviousDesiredWeightChange={handleChange(setPreviousDesiredWeight)}
                            meetingVitaminGoals={meetingVitaminGoals}
                            setMeetingVitaminGoals={setMeetingVitaminGoals}
                            desireBariatricSurgery={desireBariatricSurgery}
                            setDesireBariatricSurgery={setDesireBariatricSurgery}
                            currentlyEnrolled={currentlyEnrolled}
                            setCurrentlyEnrolled={setCurrentlyEnrolled}
                            futureCurrentWeight={futureCurrentWeight}
                            onFutureCurrentWeightChange={handleChange(setFutureCurrentWeight)}
                            futureDesiredWeight={futureDesiredWeight}
                            onFutureDesiredWeightChange={handleChange(setFutureDesiredWeight)}

                        />
                        <Grid item xs={12}>
                            <Button
                                style={{ marginBottom: 10 }}
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                disabled={sending}
                            >
                                {t('common.form.button.save')}
                                {sending && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </Button>
                        </Grid>
                    </form>
                </Grid>
            </Grid>
        </>
    );

};

export default Create;
